import { apiSlice } from '../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: [],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      confirmPaymentIntent: builder.mutation({
        query: (data) => ({
          url: `payment/direct/confirm_intent`,
          method: 'POST',
          data: data,
          useDefaultErrorHandler: false,
        }),
      }),
      createPaymentSession: builder.mutation({
        query: (data) => ({
          url: `payment/direct/create_checkout_session`,
          method: 'POST',
          data: data,
          useDefaultErrorHandler: false,
        }),
      }),
      checkPaymentAvailability: builder.mutation({
        query: (data) => ({
          url: `payment/direct/check_status`,
          method: 'POST',
          data: data,
          useDefaultErrorHandler: false,
        }),
      }),
    }),
  });

export const {
  useConfirmPaymentIntentMutation,
  useCreatePaymentSessionMutation,
  useCheckPaymentAvailabilityMutation,
} = extendedApiSlice;
